import api from "./client"
import type { BodyMetric } from "../types"

export async function getBodyMetrics(userId?: number): Promise<BodyMetric[]> {
  const params = userId ? { user_id: userId } : {}
  const { data } = await api.get<BodyMetric[]>("/body_metrics", { params })
  return data
}

export async function createBodyMetric(
  params: Record<string, unknown>,
  userId?: number,
): Promise<BodyMetric> {
  const body: Record<string, unknown> = { body_metric: params }
  if (userId) body.user_id = userId
  const { data } = await api.post<BodyMetric>("/body_metrics", body)
  return data
}

export async function deleteBodyMetric(id: number): Promise<void> {
  await api.delete(`/body_metrics/${id}`)
}
